module.exports = __webpack_public_path__ + "img/FDOC.49a6638.png";